/**
 * @enum {string}
 */
export const EventType = {
    STARTUP: 'startup',
    LAUNCH_COURSE: 'launch-course',
    LAUNCH_COURSE_LEVEL: 'launch-course-level',
    VIEW_RESOURCE: 'view-resource',
    PAGE_VIEW: 'page-view',
    // ...
};
